import { Typography } from "@repo/design-system";
import {
  MOLECULE_DETAIL_ID_KEY,
  MOLECULE_DETAIL_SMILES_KEY,
  type IMoleculeDetailsSection,
} from "@/api/moleculeDetails";
import { MoleculeCanvas } from "./MoleculeCanvas";

interface IMoleculeHeroCardProps {
  section: IMoleculeDetailsSection;
}

export function MoleculeHeroCard({ section }: IMoleculeHeroCardProps) {
  const idItem = section.items.find(
    (item) => item.key === MOLECULE_DETAIL_ID_KEY,
  );
  const smilesItem = section.items.find(
    (item) => item.key === MOLECULE_DETAIL_SMILES_KEY,
  );

  return (
    <div className="flex flex-col gap-3 rounded-2xl border border-borderPrimary bg-backgroundSecondary p-5">
      <div className="flex flex-col gap-1">
        <Typography variant="heading-3" className="text-contentPrimary">
          {section.displayName}
        </Typography>
        {idItem && (
          <Typography variant="heading-4" className="text-contentPrimary">
            {idItem.value}
          </Typography>
        )}
      </div>
      {smilesItem && (
        <Typography
          as="p"
          variant="paragraph-l-regular"
          className="break-all text-contentSecondary">
          {smilesItem.value}
        </Typography>
      )}
      {smilesItem && (
        <div className="mt-auto flex items-center justify-center rounded-xl border border-borderPrimary bg-backgroundPrimary p-3">
          <MoleculeCanvas smiles={smilesItem.value} />
        </div>
      )}
    </div>
  );
}
